<template>
    <div class="order">
        <div class="body">
            <div class="pic">
                <img :src="order.picUrl" />
            </div>
            <div class="content">
                <div class="title">{{ order.name }}</div>
                <div class="spec" v-if="order.specification">{{ order.specification }}</div>
                <div class="spec">{{ order.orderCreateTime | formatDate }}</div>
            </div>
            <div class="amount">
                <div>
                    <div class="fee">
                        <span class="unit">¥</span>
                        <order-money-font
                            :money="order.orderFee | formatMoneyFen"
                        ></order-money-font>
                    </div>
                    <div class="count">x{{ order.num }}</div>
                </div>
                <div class="status">{{ order.orderStatusView }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import { formatMoneyFen, formatDate } from '../../utils/filters';
import OrderMoneyFont from './order-money-font.vue';
export default {
    name: 'order-item',
    components: {
        OrderMoneyFont,
    },
    props: {
        order: {
            type: Object,
            default: null,
        },
    },
    filters: {
        formatMoneyFen,
        formatDate,
    },
};
</script>
<style lang="less" scoped>
.ellipsis {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.order {
    margin: 0 auto;
    width: 3.76rem;
    padding: 0.12rem;
    box-sizing: border-box;
    border-radius: 0.08rem;
    background: #f8f8f8;
    .body {
        display: flex;
        height: 0.72rem;
        .pic {
            width: 0.72rem;
            height: 0.72rem;
            border-radius: 0.08rem;
            overflow: hidden;
            flex-shrink: 0;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .content {
            width: 1.94rem;
            height: 0.72rem;
            margin-left: 0.08rem;
            & > div {
                .ellipsis();
            }
            .title {
                font-size: 0.16rem;
                line-height: 0.2rem;
            }
            .spec {
                font-size: 0.14rem;
                line-height: 0.18rem;
                margin-top: 0.08rem;
                color: #9c9c9c;
            }
        }
        .amount {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-end;
            max-width: 0.84rem;
            & > div {
                max-width: 100%;
            }
            .fee {
                font-size: 0.18rem;
                line-height: 0.2rem;
                text-align: right;
                .unit {
                    font-size: 0.12rem;
                }
                .ellipsis();
            }
            .count {
                font-size: 0.13rem;
                line-height: 0.14rem;
                color: #9c9c9c;
                text-align: right;
                margin-right: 0.01rem;
            }
            .status {
                line-height: 0.18rem;
                font-size: 0.14rem;
                color: #fe3666;
                .ellipsis();
            }
        }
    }
}
</style>
